var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import CoinIcon from "./soccoin.svg";
import { color } from "../themes";
var Coin = styled.img.attrs(function (props) { return ({
    style: {
        width: props.size + "px",
        height: props.size + "px",
        marginRight: (props.marginRight || props.size / 2) + "px",
    },
}); }).withConfig({ displayName: "Coin", componentId: "sc-19mjdie" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  user-select: none;\n  color: ", ";\n  object-fit: contain;\n"], ["\n  display: block;\n  user-select: none;\n  color: ", ";\n  object-fit: contain;\n"])), color("surfaceAttention"));
Coin.defaultProps = {
    src: CoinIcon,
    alt: "Socgress Coin",
};
export { Coin };
var templateObject_1;
